import React, { useEffect } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import scrollTo from '../../lib/js/scrollTo';

import FormControl from '../common/elements/FormControl';
import DateControl from '../common/forms/DateControl';
import Button from '../common/elements/Button.js';
import Form from '../common/forms/Form';
import { validate } from '../common/forms/Validations';

const styles = css`
  .form {
    display: flex;
    flex-direction: column;
  }
  .form__next {
    max-width: 50%;
  }
  .form__actions {
    width: 100%;
    justify-content: space-between;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    gap: 10px;
  }
`;

const buttonStyles = css.resolve`
  button {
    min-width: 170px;
    align-self: flex-end;
  }

  @media (max-width: 800px) {
    button {
      flex-grow: 1;
    }
  }
`;

const ProfileForm = ({
  beneficiary,
  beneficiaryValidators,
  saveBeneficiary,
  clearBeneficiary,
  required,
  className
}) => {
  useEffect(() => {
    scrollTo();
  });
  return (
    <Form
      initialValues={{
        ...beneficiary,
        birthday: beneficiary.birthday && beneficiary.birthday
      }}
      validate={value => validate(value, beneficiaryValidators())}
      onSubmit={saveBeneficiary}
    >
      {({ values, metas, onChange, onBlur, doSubmit, ...form }) => (
        <form className={classnames('form', className)} onSubmit={doSubmit}>
          <h2>Voyageur</h2>
          <FormControl
            name="firstname"
            label="PRÉNOM"
            autoComplete="given-name"
            type="text"
            value={values.firstname}
            onChange={onChange}
            error={metas.firstname.error}
            valid={metas.firstname.valid}
            autoFocus
            onBlur={onBlur}
            required
          />
          <FormControl
            name="lastname"
            autoComplete="family-name"
            label="NOM DE FAMILLE"
            type="text"
            value={values.lastname}
            error={metas.lastname.error}
            valid={metas.lastname.valid}
            onChange={onChange}
            onBlur={onBlur}
            required
          />
          <FormControl
            name="email"
            autoComplete="email"
            label="EMAIL"
            type="email"
            value={values.email}
            error={metas.email.error}
            valid={metas.email.valid}
            onChange={onChange}
            onBlur={onBlur}
          />
          <DateControl
            name="birthday"
            label="DATE DE NAISSANCE"
            type="date"
            autoComplete="bday"
            value={values.birthday}
            onChange={onChange}
            onBlur={onBlur}
            required
            pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
            placeholder="jj/mm/aaaa"
            error={metas.birthday.error}
            valid={metas.birthday.valid}
          />
          <FormControl
            label="PAYS DE RÉSIDENCE"
            type="text"
            name="country"
            autoComplete="country-name"
            value={values.country}
            onChange={onChange}
            onBlur={onBlur}
            error={metas.country.error}
            valid={metas.country.valid}
            required
          />
          {!required ? (
            <div className="form__actions">
              <Button
                type="submit"
                data-testid="save"
                className={buttonStyles.className}
              >
                Ajouter
              </Button>
              <Button
                type="button"
                data-testid="save"
                onClick={clearBeneficiary}
                className={buttonStyles.className}
                secondary
              >
                Annuler
              </Button>
            </div>
          ) : (
            <Button type="submit" data-testid="save">
              Ajouter
            </Button>
          )}
          <style jsx>{styles}</style>
          {buttonStyles.styles}
        </form>
      )}
    </Form>
  );
};

export default ProfileForm;
